import {Stack, Typography} from '@mui/material';
import React from 'react';
import {useTheme} from 'styled-components';
import {translations} from 'presentation/translations-new';
import {useHostName} from 'presentation/hooks';
import {AlertInfo} from '../AlertInfo';
import {AlertErrorCodeBarType} from './type';

const {paymentCode, errorCodeBar} = translations['pt-br'].privateFlow.myFinancial;

const AlertErrorCodeBar = ({isDetail}: AlertErrorCodeBarType) => {
	const {dataHostNameState} = useHostName();
	const {colors} = useTheme();
	const {line1, line2, line3, line4, line5} = errorCodeBar.description[dataHostNameState.product];
	return (
		<Stack gap={1}>
			<Typography
				fontSize={isDetail ? '1rem' : '0.75rem'}
				color={colors.light.text.secondary}>
				{paymentCode}
			</Typography>
			<AlertInfo.Root severity="error">
				<AlertInfo.Title title={errorCodeBar.title} />
				<AlertInfo.Description>
					<Typography variant="body2">
						{line1} <b>{line2}</b> {line3} <b>{line4}</b> {line5}
					</Typography>
				</AlertInfo.Description>
			</AlertInfo.Root>
		</Stack>
	);
};

export default AlertErrorCodeBar;
